import { render, staticRenderFns } from "./adminTable.vue?vue&type=template&id=5d903c53&scoped=true&"
import script from "./adminTable.vue?vue&type=script&lang=js&"
export * from "./adminTable.vue?vue&type=script&lang=js&"
import style0 from "./adminTable.vue?vue&type=style&index=0&id=5d903c53&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d903c53",
  null
  
)

export default component.exports